"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var AutocompleteInput = function (props) {
    return (props.isEditing ?
        (react_1.default.createElement(material_1.FormControl, { variant: "standard", fullWidth: true, error: props.error, sx: { marginTop: 0, marginBottom: 2 } },
            react_1.default.createElement(StyledAutoComplete, { fullWidth: true, autoComplete: true, autoHighlight: true, value: props.value, onChange: props.onChange, getOptionLabel: props.getOptionLabel, renderOption: props.renderOption, onBlur: props.onBlur, renderInput: function (params) {
                    return react_1.default.createElement(material_1.TextField, __assign({ margin: "dense", type: "string", label: props.label, variant: "standard", error: props.error, name: props.name }, params, { size: "small", required: props.required, fullWidth: true, helperText: props.helperText }));
                }, options: props.options })))
        :
            (react_1.default.createElement(material_1.FormControl, { sx: { minHeight: '50px' } },
                react_1.default.createElement(material_1.Typography, { variant: "overline", display: "block" }, props.label),
                react_1.default.createElement("span", null, props.value && (props.getOptionLabel && props.getOptionLabel(props.value)) || props.value || react_1.default.createElement("span", null, "N/A")))));
};
var StyledAutoComplete = (0, material_1.styled)(material_1.Autocomplete)(function () {
    var _a;
    return (_a = {},
        _a['.MuiFormControl-root'] = {
            marginTop: 0,
            marginBottom: 0
        },
        _a);
});
exports.default = AutocompleteInput;
